const STORAGE_KEY = "addboard.post_login_url";
const DEFAULT_URL = "/dashboard";

export function rememberPostLoginUrl(url: string): void {
  sessionStorage.setItem(STORAGE_KEY, url);
}

export function consumePostLoginUrl(): string {
  const url = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (!url || !url.startsWith("/") || url.startsWith("//")) {
    return DEFAULT_URL;
  }
  return url;
}
